import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  key: 0,
  class: "divider",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: "wiki-breadcrumbs",
    "aria-label": _ctx.$t('wiki.title')
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        class: "bread-crumb",
        key: item.to,
        to: item.to,
        "aria-current": index === _ctx.items.length - 1 ? 'page' : undefined
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(item.title), 1),
          (index !== _ctx.items.length - 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "/"))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["to", "aria-current"]))
    }), 128))
  ], 8, _hoisted_1))
}